import styled from "styled-components"

import {Hr} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import media from "@irati/ui/src/global/media"
import {IconTooltip} from "@irati/ui/src/Tooltip"

import ScheduledTransfer from "../ScheduledTransfer"

export const StyledScheduledTransfer = styled(ScheduledTransfer)`
  margin-bottom: ${padding.small};
`

export const StyledHr = styled(Hr)`
  margin: 25px 0 10px;

  ${media.tablet`
    border-top-color: ${({theme}) => theme.colors.greys.medium};
  `}
`

export const ShowMoreButton = styled(Button)`
  display: block;
  margin: 0 auto;
`

export const StyledTooltip = styled(IconTooltip)`
  padding: 6px 0 3px 5px;
`
